import React, { useEffect } from "react";
import Nomina from "../components/Nomina/Nomina";
import i18n from "../i18n/config";

const NominaPage = () => {
  useEffect(() => {
    document.title = `${window._env_.REACT_APP_EMPRESA_NAME} - ${i18n.t("layoutTitle", { ns: "nomina" })}`;
  }, []);

  return <Nomina />;
};

export default NominaPage;
